export const ROUTE_LOGIN_OUT = "/login";
export const ROUTE_HOME = "/chat";
export const ROUTE_ITEM = "/item";
export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_LOGGING_IN = "/auth/:jwt?";
